<template>
  <!-- eslint-disable -->
  <svg
    version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 100 100" style="enable-background: new 0 0 100 100;" xml:space="preserve"
  >
    <g>
      <path
        id="right" style="fill: #17b0e4;" d="M85.9,97.8c0,0-22.3,2.2-35.9,2.2V71.9l28.7,5C82.8,89,85.9,97.8,85.9,97.8z M66.4,41.3
        L50,33.2v19.5l22.5,6.8L66.4,41.3z M53.6,4.3c-1.5-4.2-3.5-4-3.5-4v18.6L61,25.3C57,14,54,5.7,53.6,4.3z"
      />
      <path id="left" style="fill: #3c5ca8;" d="M50,100V0.2c0,0-2.1-0.1-3.5,4c-1.7,4.9-32.4,93.6-32.4,93.6S36.4,100,50,100z" />
      <path
        id="left2" style="fill: #17b0e4;" d="M27.5,59.4L50,52.7v19.2l-28.7,5C23.3,71.5,25.2,65.6,27.5,59.4z M33.7,41.3L50,33.2
        V18.7l-10.9,6.4C37.5,30.2,35.7,35.7,33.7,41.3z"
      />
    </g>
  </svg>
  <!-- eslint-enable -->
</template>

<script>
  export default {
    name: 'BankIdFI'
  }
</script>
